module.exports = __webpack_public_path__ + "img/insurance-card-supp.05ee116.png";